import { render, staticRenderFns } from "./ControlPollo.vue?vue&type=template&id=232a24ad&scoped=true&"
import script from "./ControlPollo.vue?vue&type=script&lang=js&"
export * from "./ControlPollo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232a24ad",
  null
  
)

export default component.exports